import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/* ------------------------------------------------------------------ */
/* TABS (OPTIONAL, FUTURE-READY) */
/* ------------------------------------------------------------------ */

export const CUSTOM_INPUT_TABS = ["Fields", "Options", "Scopes"] as const;

export type CustomInputTabType = (typeof CUSTOM_INPUT_TABS)[number];

/* ------------------------------------------------------------------ */
/* STATE */
/* ------------------------------------------------------------------ */

export interface CustomInputState {
  isAddCustomInput: boolean;
  isEditCustomInput: boolean;
  isDeleteCustomInput: boolean;

  currentTab: CustomInputTabType;
  customInputId?: number;
}

const initialState: CustomInputState = {
  isAddCustomInput: false,
  isEditCustomInput: false,
  isDeleteCustomInput: false,

  currentTab: "Fields",
  customInputId: undefined,
};

/* ------------------------------------------------------------------ */
/* SLICE */
/* ------------------------------------------------------------------ */

const customInputSlice = createSlice({
  name: "custom-input-functional",
  initialState,
  reducers: {
    setIsAddCustomInput(state, action: PayloadAction<boolean>) {
      state.isAddCustomInput = action.payload;
    },
  },
});

/* ------------------------------------------------------------------ */
/* ACTIONS */
/* ------------------------------------------------------------------ */

export const { setIsAddCustomInput } = customInputSlice.actions;

export default customInputSlice.reducer;
